import { Container } from "@mui/material"
import styled, { css } from "styled-components"

export const bottomBarContainerCss = css`
  padding: 10px;
  display: flex;
  align-items: center;
  background-color: ${(p) => p.theme.colors.white};

  ${(p) => p.theme.breakpoints.down("sm")} {
    height: 64px;
    border-top: 1px solid ${(p) => p.theme.colors.borderGrey};
    box-shadow: 0 -5px 25px 0 rgba(0, 0, 0, 0.15);
    flex-wrap: wrap;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    width: auto;
    min-height: 80px;
  }
`
export const StyledContainer = styled(Container).attrs({ maxWidth: false })`
  ${bottomBarContainerCss}
`
